import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateTransactionRequestDto,
  TransactionRequestsFacade,
} from './transaction-requests.facade';
import { TransactionRequestV4 } from '@models/resources/transaction-request.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante (Sprint 5c S5c-8 + V4-Refactor S5c-10/11). Active when
 * `environment.dataSource === 'http'`.
 *
 * Wire-Contract (V4):
 * - `GET  /api/me/transaction-requests` → `TransactionRequestV4[]`
 * - `POST /api/me/transaction-requests` → `TransactionRequestV4`
 *
 * Buy-Body: `{ type: 'buy', metal_id, amount_eur, note? }`.
 * Sell-Body: `{ type: 'sell', metal_id, requested_grams, note? }`.
 * Backend validiert type-conditional (`CreateTransactionRequestRequest`)
 * und macht beim Sell den Reichweiten-Check gegen `depot_positions`.
 */
@Injectable()
export class HttpTransactionRequestsFacade implements TransactionRequestsFacade {
  private readonly http = inject(HttpClient);

  list(): Observable<TransactionRequestV4[]> {
    return this.http.get<TransactionRequestV4[]>(
      `${environment.apiUrl}/me/transaction-requests`,
    );
  }

  create(dto: CreateTransactionRequestDto): Observable<TransactionRequestV4> {
    return this.http.post<TransactionRequestV4>(
      `${environment.apiUrl}/me/transaction-requests`,
      dto,
    );
  }
}
